import { Node_Type } from "./../wix-rich-content-common";
const TABLE_TYPE = "wix-rich-content-plugin-table";
const tableModals = {
  insert: `${Node_Type.TABLE}.insert`
};
export {
  TABLE_TYPE,
  tableModals
};
//# sourceMappingURL=types.js.map
